<!--
 * @Author: kenneth
 * @Date: 2023-07-10 15:53:26
 * @Last Modified by: egafrandika
 * @Last Modified time: 2024-03-22 10:41:51
-->

<template>
    <tab>
        <div class="lend">
            <yqg-md-preview :md-text="$t('mdText', [yqdContact.email, finContact.email])" />
        </div>
    </tab>
</template>

<script type="text/babel">
import {mapState} from 'vuex';

import Tab from '../../component/tab';
import EN_US from './constant/en-us';
import ID from './constant/id';

export default {
    name: 'Lend',

    i18n: {
        messages: {
            en: {mdText: EN_US},
            id: {mdText: ID}
        }
    },

    computed: {
        ...mapState('contact', [
            'yqdContact',
            'finContact'
        ])
    },

    components: {
        Tab
    }
};

</script>
